/* eslint-disable radix */
/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from 'src/api/api-client';
import {
  serviceCategoryURI,
  getProcessURI,
  getListIotProjectURI,
  upsertIotProjectURI,
} from '../api';
import { setValue } from './MessageSlice';
// First, create the thunk
export const fetchServiceCategories = createAsyncThunk(
  'serviceCategories/fetchServiceCategories',
  async (page = 1, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${serviceCategoryURI}`,
        })
        .then(res => res.data);
      return response;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const fetchServiceProcess = createAsyncThunk(
  'serviceCategories/fetchServiceProcess',
  async (page = 1, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${getProcessURI}`,
        })
        .then(res => res.data);
      return response;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const fetchServiceProject = createAsyncThunk(
  'serviceCategories/fetchServiceProject',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${getListIotProjectURI}`,
          params: { limit: 1000, page: 1 },
        })
        .then(res => res.data);
      if (data && data.dataProject) {
        const convertArray = data.dataProject.map((item, index) => parseInt(item));
        response.data.filter(project => convertArray.includes(project.id));
        return response;
      }
      return response;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const upsertProject = createAsyncThunk(
  'serviceCategories/upsertProject',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'post',
          url: `${upsertIotProjectURI}`,
          data: data.data,
        })
        .then(res => res.data);
      dispatch(fetchServiceProject());
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

// Then, handle actions in your reducers:
const serviceCategorySlice = createSlice({
  name: 'serviceCategories',
  initialState: {
    entities: [],
    loading: 'idle',
    saving: 'idle',
    currentRequestId: undefined,
    error: null,
    currentPage: 1,
    totalPage: 1,
    total: 0,
    process: [],
    project: [],
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchServiceCategories.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchServiceCategories.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        const { data, last_page, current_page, total } = action.payload;
        state.loading = 'idle';
        state.entities = data;
        state.currentPage = current_page;
        state.totalPage = last_page;
        state.currentRequestId = undefined;
        state.total = total;
      }
    },
    [fetchServiceCategories.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [fetchServiceProcess.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.process = data;
    },
    [fetchServiceProject.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.project = data.map(item => {
        if (item.id === 1 || item.id === 2 || item.id === 3) {
          return { value: item.id, label: item.name, disabled: true };
        }
        return { value: item.id, label: item.name };
      });
    },
    [upsertProject.pending]: (state, action) => {
      if (state.saving === 'idle') {
        state.saving = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    [upsertProject.fulfilled]: (state, action) => {
      state.saving = 'idle';
    },
    [upsertProject.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.saving === 'pending' && state.currentRequestId === requestId) {
        state.saving = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
  },
});

export default serviceCategorySlice.reducer;
